// extracted by mini-css-extract-plugin
export default {"box":"SelectBankAccount_box__Um+nx","selected":"SelectBankAccount_selected__k9BuC","check":"SelectBankAccount_check__jim9z"};